/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElTable as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElTableColumn as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-03ba799d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "card-title",
  id: "card-title-params"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自定义参数", -1));
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除");
const _hoisted_5 = /*#__PURE__*/_createTextVNode("添加");
import { UseComProps } from './hooks';
import { UseGlobalConfig } from '@/utils/hooks';
import SaveBtn from './saveBtn.vue';
import { apiUsdkGetCustomParamEdit, apiUsdkDelCustomParamEdit, apiUsdkSetCustomParamEdit } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  props: {
    ...UseComProps()
  },
  setup(__props) {
    const props = __props;
    const tableData = ref([]);
    const loadingTable = ref(false);
    const loadingSave = ref(false);
    // 获取自定义参数
    const getCustomParam = () => {
      loadingTable.value = true;
      apiUsdkGetCustomParamEdit({
        gid: props.gid,
        cid: props.channel && props.channel.cid
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
          tableData.value.push({
            gid: props.gid,
            pKey: '',
            pVal: ''
          });
        }
      }).finally(() => {
        loadingTable.value = false;
      });
    };
    const handleClick = (type, data, index) => {
      if (type === 'add') {
        tableData.value.push({
          gid: props.gid,
          pKey: '',
          pVal: ''
        });
      } else {
        if (data.pid) {
          ElMessageBox.confirm(`是否确认删除【${data.pKey}】`, '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            apiUsdkDelCustomParamEdit({
              id: data.pid
            }).then(res => {
              if (res.code === 0) {
                tableData.value.splice(index, 1);
              }
            });
          }).catch(() => {
            console.log('取消');
          });
        } else {
          tableData.value.splice(index, 1);
        }
      }
    };
    const isEdit = ref(false);
    const handleClickSave = type => {
      if (type === 'edit') {
        isEdit.value = true;
      } else if (type === 'cancel') {
        isEdit.value = false;
      } else {
        handleSave();
      }
    };
    const handleSave = () => {
      let paramsList = JSON.stringify(tableData.value.filter(item => item.pKey));
      ElMessageBox.confirm('<ul><li>· 删除/新增参数键名会一并对所有渠道生效，键名是游戏全部渠道公用的</li><li>· 删除/编辑参数键值仅对当前渠道生效，其他渠道如需修改键值请在对应渠道中修改</li></ul>', '提示', {
        confirmButtonText: '已熟知确认保存',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        loadingSave.value = true;
        apiUsdkSetCustomParamEdit({
          gid: props.gid,
          cid: props.channel && props.channel.cid,
          paramsList
        }).then(res => {
          if (res.code === 0) {
            getCustomParam();
            isEdit.value = false;
          }
        }).finally(() => {
          loadingSave.value = false;
        });
      }).catch(() => {
        console.log('取消');
      });
    };
    const {
      $channel
    } = UseGlobalConfig();
    onMounted(() => {
      var _props$channel;
      getCustomParam();
      const dom = document.querySelector('#card-title-params');
      const isShowSign = ((_props$channel = props.channel) === null || _props$channel === void 0 ? void 0 : _props$channel.plat) === 0;
      const isShowTheme = [$channel.OFFICIAL_CHANNEL, $channel.OFFICIAL_IOS_CHANNEL, $channel.GLOBAL_OFFICIAL_CHANNEL, $channel.GLOBAL_OFFICIAL_IOS_CHANNEL].includes(props.channel.channel);
      if (isShowSign && isShowTheme) {
        dom.style.top = '360px';
      } else if (isShowSign && !isShowTheme) {
        dom.style.top = '300px';
      } else if (!isShowSign && isShowTheme) {
        dom.style.top = '300px';
      } else {
        dom.style.top = '239px';
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_table_column = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_el_table = __unplugin_components_3;
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, !isEdit.value ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "btn-color cp",
        onClick: _cache[0] || (_cache[0] = $event => handleClickSave('edit'))
      }, "[编辑]")) : (_openBlock(), _createBlock(SaveBtn, {
        key: 1,
        loading: loadingSave.value,
        onCancel: handleClickSave,
        onSave: handleClickSave
      }, null, 8, ["loading"]))]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "tableRef",
        data: tableData.value,
        style: {
          "width": "100%"
        },
        class: "marginT20"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "pKey",
          label: "参数键名",
          width: "300"
        }, {
          default: _withCtx(scope => [scope.$index < tableData.value.length - 1 && scope.row.pid ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row.pKey), 1)) : (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            class: "width200px",
            modelValue: scope.row.pKey,
            "onUpdate:modelValue": $event => scope.row.pKey = $event,
            disabled: !isEdit.value
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "pval",
          label: "键值",
          width: "300"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input, {
            class: "width200px",
            modelValue: scope.row.pVal,
            "onUpdate:modelValue": $event => scope.row.pVal = $event,
            disabled: !isEdit.value
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [scope.$index < tableData.value.length - 1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            disabled: !isEdit.value,
            onClick: $event => handleClick('del', scope.row, scope.$index),
            size: "small",
            link: "",
            type: "danger"
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 2
          }, 1032, ["disabled", "onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            link: "",
            type: "primary",
            disabled: !isEdit.value,
            onClick: $event => handleClick('add', scope.row, scope.$index)
          }, {
            default: _withCtx(() => [_hoisted_5]),
            _: 2
          }, 1032, ["disabled", "onClick"]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loadingTable.value]])]);
    };
  }
});